import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  IExam,
  SaqCandidateQuestionModel
} from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-view-script',
  templateUrl: './view-exam-script.component.html',
  styleUrls: ['./view-exam-script.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewExamScriptComponent implements OnInit {
  mode = 'mark';
  candidatesQuestionsData: SaqCandidateQuestionModel[] = [];
  selectedCandidateQuestion: SaqCandidateQuestionModel|null = null;
  adjustmentData = { score: 0, reason: '' };
  html: string="";
  showUnansweredSAQ: boolean = false;
  excludeTestCandidates: boolean = true;

  constructor(
    private snackBar: SnackbarService,
    private examService: ExamService,
    private examSchService: ExamScheduleService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
  ) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.showUnansweredSAQ = params['showUnansweredSAQ'] || false;
      this.excludeTestCandidates = params['excludeTestCandidates'] || true;
      console.log(this.showUnansweredSAQ,"showUnansweredSAQ");
      
    });

    // const selectedExamID = this.examService.selectedExamIds?.[0];
    const selectedSchID = this.examSchService.selectedIds?.[0] ?? this.getScheduleIdFromRoute() ?? 0;
    const res: any = await this.examSchService.getScheduleDetails(selectedSchID);

    //console.log("Selected Schedule:", this.examSchService.selectedIds);
    //console.log(this.examSchService.selectedSchedules);
    const selectedExamID = res?.examinationID ?? this.examService.selectedExamIds?.[0];
    if (!selectedExamID) {
      console.warn('Missing required IDs:', { selectedExamID, selectedSchID });
      return;
    }

    try {
      const rawResponse = await this.examService.getExamScriptHtmlContent(selectedExamID, selectedSchID,this.showUnansweredSAQ, this.excludeTestCandidates);
      const response = rawResponse as { file: string; fileName: string };

      if (!response?.file) {
        this.snackBar.error('There are no schedules for this exam.');
        return;
      }

      this.html = atob(response.file);
    } catch (error) {
      console.error('Error loading exam script content:', error);
      this.snackBar.error('Error loading exam script content');
    }
    document.getElementById('printPageBtn').addEventListener('click', () => {
      window.print();
    });
  }

  // For when the page refreshes or is accessed via direct link, somehow the examScheduleService.selectedIds become undefined. If that is fixed, this won't be needed anymore
  private getScheduleIdFromRoute(): number | null {
    const fullUrl = window.location.pathname;
    const scheduleMatch = fullUrl.match(/schedules\/(\d+)/);
    //console.log("Full URL", fullUrl);
    //console.log("Schedule Match", scheduleMatch);
    return scheduleMatch ? parseInt(scheduleMatch[1], 10) : null;
  }
}
